export type TCb = {
  success?: (data?: any) => void;
  fail?: (data?: any) => void;
  error?: (data?: any) => void;
};

export enum UserGender {
  MAN,
  WOMAN,
}

export const UserGenderOptions: { id: UserGender; name: string }[] = [
  {
    id: UserGender.MAN,
    name: "Nam",
  },
  {
    id: UserGender.WOMAN,
    name: "Nữ",
  },
];

export type IconModel = {
  color: string;
  size: [number, number]; // mang kich thuoc x,y (width, height)
  viewBox?: [number, number]; // mang kich thuoc x,y (width, height)
  className?: string;
  style?: React.CSSProperties;
  options?: {
    color: string;
    backgroundColor: string;
  };
};

export type PaginationQueryModel = {
  page?: number;
  limit?: number;
};

export type PaginationLanguageQueryModel = {
  page: number;
  limit: number;
  languageId: string;
};

export type FetchingPaginationDataModel<T> = {
  page: number;
  totalPages: number;
  limit: number;
  totalRecords: number;
  data: T[];
  loading: boolean;
};

export type FetchingDataModel<T> = {
  data: T;
  loading: boolean;
};

export enum FORM_MODE {
  CREATE,
  EDIT,
  VIEW,
}

export enum VIDEO_MODE {
  HOMEPAGE,
  RESOURCE,
}

/**
 * dùng cho <ImageUpload />
 */
export type UploadedImageModel = {
  id?: string;
  file: any;
  fileStr: any;
  alt?: string;
};

export type FormUploadImageModel = {
  id: string;
  src: string;
  alt?: string;
};
